import e from"./RefinementList.vue_vue&type=script&lang.js";import{render as t}from"./RefinementList.vue_vue&type=template&id=36cfaf16&lang.js";e.render=t;export default e;
//# sourceMappingURL=RefinementList.vue.js.map
